module.exports = __webpack_public_path__ + "static/media/HelpIcon.6d713770.svg";